// Generated from RouteLogEntry's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type RouteLogEntryCollectionFilterGroups
  = | {
    readonly route: Iri
  }

export const routeLogEntryCollectionFilterMapping: FilterDefinitionMapping<RouteLogEntryCollectionFilterGroups> = {
  route: 'route',
}

export type RouteLogEntryCollectionSort = never
